import Button from "react-bootstrap/Button";
import { Modal, Stack } from "react-bootstrap";
import LoadingIndicator from "./LoadingIndicator";

export default function LoadingModal({
    handleConfirm,
    handleClose,
    show,
    loading,
    descriptionText = "",
    readyText = "Processing is done",
    confirmText = "Next",
    cancelText = "OK, Close",
    titleText = "Processing...",
}) {
    return (
        <>
            <Modal show={show} onHide={handleClose} centered keyboard={false}>
                <Modal.Header closeButton closeVariant={"white"}>
                    <Modal.Title>{titleText}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Stack gap={3}>
                        {descriptionText && <span>{descriptionText}</span>}
                        {loading ? <LoadingIndicator width={150} showText={false} /> : <span className="fw-bold">{readyText}</span>}
                    </Stack>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" className=" btn-ra-yellow" onClick={handleConfirm} disabled={loading}>
                        {confirmText}
                    </Button>
                    <Button variant="secondary" className=" btn-ra-dark-blue" onClick={handleClose}>
                        {cancelText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
